import React from 'react'
import styled from 'styled-components'

import { theme } from '../constants/theme'

import { Sidebar } from './Sidebar'

export const Layout = ({ children }) => (
  <Wrapper>
    <Sidebar />
    {children}
  </Wrapper>
)

const Wrapper = styled.div`
  background: ${theme.colors.bodyGray};
  @media (min-width: 1000px) {
    padding-left: ${theme.spacing.sidebarWidth}px;
  }
`
